import React, { Component } from 'react';
import AccountCircle from 'material-ui/svg-icons/action/account-circle';
import Avatar from 'material-ui/Avatar';
import FlatButton from 'material-ui/FlatButton';
import Dialog from 'material-ui/Dialog';
import {greenA700} from 'material-ui/styles/colors'
import { FormattedMessage, intlShape } from 'react-intl';

const localeMessages = {
  deny: {
    id: "Supporter.IncomingCall.Deny",
    defaultMessage: "Ablehnen"
  },
  accept: {
    id: "Supporter.IncomingCall.Accept",
    defaultMessage: "Annehmen"
  },
  endaccept: {
    id: "Supporter.IncomingCall.EndAccept",
    defaultMessage: "Annehmen und laufendes Gespräch beenden"
  },
  newcall: {
    id: "Supporter.IncomingCall.NewCall",
    defaultMessage: "Neuer Anruf für Sie ({name})"
  },
  ipinfo: {
    id: "Supporter.IncomingCall.IPInfo",
    defaultMessage: "IP: {ip} mit {agent}"
  },
};

class IncomingCall extends Component {
  static contextTypes = {
    intl: intlShape.isRequired,
  }

  render() {
    const actions = [
      <FlatButton
        label={this.context.intl.formatMessage(localeMessages.deny)}
        primary={true}
        style={{color: 'red'}}
        onClick={() => this.props.deny(this.props.contact)}
      />,
      <FlatButton
        label={this.props.calling ? this.context.intl.formatMessage(localeMessages.endaccept) : this.context.intl.formatMessage(localeMessages.accept)}
        primary={true}
        style={{color: greenA700}}
        onClick={() => this.props.accept(this.props.contact)}
      />
    ];

    const agent = this.props.contact.agent || {};
    const contact = this.props.contact;

    return (
      <Dialog
        actions={actions}
        title={<div style={{verticalAlign: 'top'}}>
          <Avatar
            icon={<AccountCircle />}
            size={44}
            style={{marginRight:'16px', float: 'left'}}
          />
          <span>
            <FormattedMessage
              id="Supporter.IncomingCall.NewCall"
              values={{
                name: this.props.contact.name
              }}
              defaultMessage="Neuer Anruf für Sie ({name})"
            /><br/>
            <span style={{opacity:0.6, fontSize: '0.75em', whiteSpace: 'nowrap'}}>
              <FormattedMessage
                id="Supporter.IncomingCall.IPInfo"
                values={{
                  ip: contact.ip,
                  agent: (agent ? agent.browser.name : '') + " " + (agent ? agent.os.name : '')
                }}
                defaultMessage="IP: {ip} mit {agent}"
              /></span>
          </span>
        </div>}
        open={true}
      >
      </Dialog>
    );
  }
};

export default IncomingCall;


// WEBPACK FOOTER //
// ./src/IncomingCall.js